module.exports = __webpack_public_path__ + "img/project15_4.jpeg.d519333c.webp";